import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

interface LearningProgressPayload {
  lessonId: string;
  score: number;
  timeSpent: number;
  completed: boolean;
}

interface AdaptiveState {
  currentDifficulty: number;
  progressHistory: LearningProgressPayload[];
}

const initialState: AdaptiveState = {
  currentDifficulty: 3,
  progressHistory: [],
};

export const updateLearningProgress = createAsyncThunk(
  'adaptive/updateProgress',
  async (payload: LearningProgressPayload) => {
    // Could call backend API here in the future
    return payload;
  }
);

const adaptiveSlice = createSlice({
  name: 'adaptive',
  initialState,
  reducers: {
    setDifficulty(state, action: PayloadAction<number>) {
      state.currentDifficulty = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateLearningProgress.fulfilled, (state, action) => {
      state.progressHistory.push(action.payload);
      // Auto-adjust difficulty based on recent scores
      const recent = state.progressHistory.slice(-5);
      const avgScore = recent.reduce((sum, p) => sum + p.score, 0) / recent.length;
      if (avgScore > 80 && state.currentDifficulty < 5) {
        state.currentDifficulty += 1;
      } else if (avgScore < 40 && state.currentDifficulty > 1) {
        state.currentDifficulty -= 1;
      }
    });
  },
});

export const { setDifficulty } = adaptiveSlice.actions;
export default adaptiveSlice.reducer;
